// Budgets status Ids
export const ACTIVE = 1;
export const IN_REVIEW = 2;
export const REJECTED = 3;
export const APPROVED = 4;
export const WITH_ERROR = 5;
